import React from 'react';
import { LegalDocument } from '../components/LegalLayout';
import { legalContent } from '../content/legal';
import { useLang } from '../i18n';

const PrivacyPolicy = () => {
  const { lang } = useLang();
  const c = legalContent[lang] || legalContent.en;
  return <LegalDocument doc={c.privacy} updated={c.updatedLabel} />;
};

export default PrivacyPolicy;
